import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=015a0d56"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports